import { motion } from "framer-motion";
import project1 from "../assets/images/project1.avif";
import project2 from "../assets/images/project2.avif";
import project3 from "../assets/images/project3.avif";
import project4 from "../assets/images/project4.avif";
import ReactGa4 from "react-ga4";

const PROJECTS = [
    {
        img: project3,
        title: "Armory - Military Asset Management System (MERN Stack)",
        desc: "A web application for managing military assets using React, Node.js, Express.js, MongoDB and RBAC using JWT.",
        link: "https://github.com/RahulPPrabhu/Armory",
        url: "https://armory-one.vercel.app/",
    },
    {
        img: project4,
        title: "TripSage.ai - AI Itinerary Planner (Next.js)",
        desc: "A web application for planning trips using Groq and Next.js for SEO and full stack development.",
        link: "https://github.com/RahulPPrabhu/TripSage.ai",
        url: "https://trip-sage-ai-blue.vercel.app/",
    },
    {
        img: project1,
        title: "Music Therapy Using MEAN Stack & ML",
        desc: "Predicts mental disorders using Random Forest and recommends music using cosine similarity.",
        link: "https://github.com/RahulPPrabhu/Music-Therapy",
    },
    {
        img: project2,
        title: "Smart City Management System (J2EE)",
        desc: "A centralized portal for travel, education, jobs, and PGs using Java, JDBC, Servlet, MySQL.",
        link: "https://github.com/RahulPPrabhu/Smart-City-Management-System",
    }
];

export const Projects = () => {
    const handleClick = (url) => {
        ReactGa4.event({
            category: "Projects",
            action: "Click",
            label: url
        });
    };

    return (
        <section id="projects" className="py-20 text-center overflow-x-hidden">
            <motion.h2
                className="text-3xl font-semibold text-white mb-10"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
            >
                Projects
            </motion.h2>

            <div className="grid lg:grid-cols-2 gap-8 mx-auto max-w-5xl px-4">
                {PROJECTS.map((project, index) => (
                    <motion.div
                        key={project.title}
                        className="bg-[#0f172a] border border-gray-700/80 p-5 rounded-xl shadow-xl flex flex-col justify-between"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-50px" }}
                        whileHover={{ y: -6 }}
                    >
                        <div>
                            <div className="w-full aspect-video overflow-hidden rounded-lg bg-slate-900">
                                <motion.img
                                    src={project.img}
                                    alt={`Screenshot of ${project.title}`}
                                    className="w-full h-full object-cover rounded-lg"
                                    loading="lazy"
                                    decoding="async"
                                    whileHover={{ scale: 1.05 }}
                                    transition={{ duration: 0.3 }}
                                />
                            </div>

                            <h3 className="mt-4 text-xl font-semibold text-gray-50 text-left">
                                {project.title}
                            </h3>
                            <p className="mt-2 text-gray-300 text-sm leading-relaxed text-left">
                                {project.desc}
                            </p>
                        </div>

                        <div className="mt-6 flex flex-wrap gap-3">
                            {project.url && (
                                <a
                                    href={project.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={`Visit live demo for ${project.title}`}
                                    className="px-4 py-2 rounded-lg bg-emerald-700 text-white text-sm font-semibold hover:bg-emerald-800 transition shadow-sm"
                                    onClick={() => handleClick(project.url)}
                                >
                                    Live Demo
                                </a>
                            )}

                            <a
                                href={project.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={`View GitHub repository for ${project.title}`}
                                className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 transition shadow-sm"
                                onClick={() => handleClick(project.link)}
                            >
                                GitHub
                            </a>
                        </div>
                    </motion.div>
                ))}
            </div>

            <motion.div
                className="mt-12"
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
            >
                <a
                    href="https://github.com/RahulPPrabhu/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="View more projects on Rahul P Prabhu's GitHub profile"
                    className="inline-block bg-blue-600 text-white font-semibold py-2.5 px-6 rounded-full hover:bg-blue-700 transition"
                >
                    View More on GitHub
                </a>
            </motion.div>
        </section>
    );
};